import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';
import MultiDropDown from '../Components/MultiDropdown';

var sessiondata = sessionStorage.getItem("User_Info");
class ViewUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            name: '',
            phone: '',
            logo: '',
            city: '',
            zip: '',
            address: '',
            details: '',
            stateAddress: '',
            typeHierarchy: [],
            departmentSelected: [],
            equipmentSelected: [],
            unitSelected: [],
            rating: 0,
            dynamicSelectedType: [],
            image: '',
            designation: '',
            allFormData: {},
            uniqueID: '',
            deletePopup: false,
            errors: {
                // name: '',
                // email: '',
                // cpassword: '',

                // password: '',

            }
        }
    }

    checkRequirement = (name, value) => {
        let errors = this.state.errors;

        switch (name) {
            case 'name':
                errors.name =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;

            // case 'password':
            //     errors.password =
            //         value.length < 8
            //             ? 'Password must be 8 characters long!'
            //             : '';
            //     break;
            // case 'cpassword':
            //     errors.password =
            //         this.state.password !== value
            //             ? 'Password and Confirm Password does not match!'
            //             : '';
            //     break;
            default:
                break;
        }

        this.setState({ errors });
    }

    onChangeInput = (e) => {
        e.preventDefault();

        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                image: reader.result
            });

        };
    }





    submit = (e) => {
        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {


        } else {
            swal("Invalid Input ..!!")
            return
        }

        // if (this.state.password != this.state.cpassword) {
        //     swal("Invalid Password ..!!")
        //     return
        // }
        var getselected = [];
        this.state.dynamicSelectedType.map((list, index) => list.length != 0 ? getselected.push(list.map((li, ind) => li.id)) : undefined)

        var filteredSelectedTypes = [].concat.apply([], getselected);
        var x = $('input[name="user_type"]:checked').val()

        var data = {
            name: this.state.name,
            phone: this.state.phone,
            // type_id: filteredSelectedTypes,
            status: this.state.status,
            usertype: x === "SME" ? 1 : 2,
            address: this.state.address,
            id: this.state.id,
            new_profile: this.state.image,
            old_profile: JSON.parse(sessiondata).profile,
            city: this.state.city,
            state: this.state.stateAddress,
            zip: this.state.zip,
            designation: this.state.designation,
            uniqueID: this.state.uniqueID,
            main_status: 1,
            user_update_status: {
                name: this.state.name == JSON.parse(sessiondata).name ? "0" : "1",
                phone: this.state.phone == JSON.parse(sessiondata).phone ? "0" : "1",
                usertype: (x === "SME" ? 1 : 2) == JSON.parse(sessiondata).usertype ? "0" : "1",
                profile: this.state.image == "" ? "0" : "1",
                address: this.state.address == JSON.parse(sessiondata).address ? "0" : "1",
                city: this.state.city == JSON.parse(sessiondata).city ? "0" : "1",
                state: this.state.stateAddress == JSON.parse(sessiondata).state ? "0" : "1",
                zip: this.state.zip == JSON.parse(sessiondata).zip ? "0" : "1",
                types: "0"
            }
        }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        window.location.href = "/create/listuser";
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.submit(e);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    submitDeleteApproved = () => {
        var _this = this;
        var data = {
            name: JSON.parse(sessiondata).name,
            phone: JSON.parse(sessiondata).phone,
            status: 0,
            usertype: JSON.parse(sessiondata).user_type === "SME" ? 1 : 2,
            address: JSON.parse(sessiondata).address,
            id: JSON.parse(sessiondata).login_id,
            old_profile: JSON.parse(sessiondata).profile,
            new_profile: "",
            state: JSON.parse(sessiondata).state,
            city: JSON.parse(sessiondata).city,
            zip: JSON.parse(sessiondata).zip,
            designation: JSON.parse(sessiondata).designation,
            email: JSON.parse(sessiondata).email,
            uniqueID: JSON.parse(sessiondata).uniqueID,
            main_status: 0,
            user_update_status: {
                name: "0",
                phone: "0",
                usertype: "0",
                profile: "0",
                address: "0",
                city: "0",
                state: "0",
                zip: "0",
                types: "0"
            }
        }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }

        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    _this.setState({ deletePopup: false })
                    if (response.data.error == false) {
                        swal(response.data.message)
                        window.location.href = "/create/listuser";
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.submitDeleteApproved();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    convert = (array) => {
        var map = {};
        for (var i = 0; i < array.length; i++) {
            var obj = array[i];
            obj.children = [];

            map[obj.id] = obj;

            var parent_id = obj.parent_id || '-';
            if (!map[parent_id]) {
                map[parent_id] = {
                    children: []
                };
            }
            map[parent_id].children.push(obj);
        }

        return map['-'].children;

    }


    componentDidMount() {

        if (sessiondata != "") {
            this.setState({
                allFormData: JSON.parse(sessiondata),
                name: JSON.parse(sessiondata).name,
                phone: JSON.parse(sessiondata).phone,
                status: JSON.parse(sessiondata).mainStatus,
                address: JSON.parse(sessiondata).address,
                stateAddress: JSON.parse(sessiondata).state,
                city: JSON.parse(sessiondata).city,
                zip: JSON.parse(sessiondata).zip,
                id: JSON.parse(sessiondata).login_id,
                old_profile: `${SERVER_IP}/icons/${JSON.parse(sessiondata).profile}`,
                new_profile: "",
                user_type: JSON.parse(sessiondata).user_type,
                email: JSON.parse(sessiondata).email,
                designation: JSON.parse(sessiondata).designation,
                uniqueID: JSON.parse(sessiondata).uniqueID,
                user_action: JSON.parse(sessiondata).user_action,


            });
        } else {
            window.location.href = '/create/listuser';
        }

        // this.getTotalType()
        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }
    getTotalType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        var heirarchy = this.state.heirarchy
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
            .then(function (response) {

                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    // var r = currentComponent.convert(heirarchy)

                    var temparr = [];
                    r.map((list, index) => { temparr.push([]) })
                    _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeDropdownDepartment = (currentNode, selectedNodes) => {

        this.setState({ departmentSelected: selectedNodes })
    }
    onChangeDropdownEquipment = (currentNode, selectedNodes) => {
        this.setState({ equipmentSelected: selectedNodes })

    }
    onChangeDropdownUnit = (currentNode, selectedNodes) => {
        this.setState({ unitSelected: selectedNodes })
    }
    onAction = (node, action) => {
        // console.log('onAction::', action, node)
    }
    onNodeToggle = currentNode => {
        // console.log('onNodeToggle::', currentNode)
    }
    onChangeDropdown = (index, currentNode, selectedNodes) => {
        this.state.dynamicSelectedType[index] = selectedNodes;
        this.setState(this.state)
    }
    submitDelete = () => {
        this.setState({ deletePopup: true });
    }

    render() {
        const { errors } = this.state;
        return (
            <div>
                <div>
                    <div class="xp-breadcrumbbar">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <h4 class="xp-page-title">User Profile</h4>
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="xp-breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                        <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser_cadmin"}>List Users</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div className="xp-contentbar">
                            <div className="row">
                                <div className="">
                                    <div className="card m-b-30">
                                        <div className="card-header bg-primary">
                                            <h5 className="card-title text-white">User Profile</h5>
                                        </div>
                                        <div className="card-body">
                                            <div class="xp-social-profile-middle text-center">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="xp-social-profile-avatar text-center">
                                                            <img src={this.state.old_profile} alt="user-profile" class="rounded-circle img-fluid" style={{ height: "200px" }} />
                                                        </div>
                                                        <div class="xp-social-profile-title">
                                                            <h5 class="my-1 text-black">{this.state.name}</h5>
                                                        </div>
                                                        <div class="xp-social-profile-subtitle">
                                                            <p class="mb-3 text-muted">{this.state.uniqueID}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="profile-list">
                                                <li><label>Name</label><p>{this.state.name}</p></li>
                                                <li><label>Email</label><p>{this.state.email}</p></li>
                                                <li><label>Phone</label><p>{this.state.phone}</p></li>
                                                <li><label>Address</label>{this.state.address}<p></p></li>
                                                <li><label>City</label><p>{this.state.city}</p></li>
                                                <li><label>State</label><p>{this.state.stateAddress}</p></li>
                                                <li><label>ZIP</label><p>{this.state.zip}</p></li>
                                                <li><label>User Type</label><p>{this.state.user_type}</p></li>
                                                <li><label>Designation</label><p>{this.state.designation}</p></li>
                                                <li><label>ID</label><p>{this.state.uniqueID}</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>




            </div>
        )
    }
}
export default ViewUser

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}